<div class="global-search-container">
	<button
		(click)="closeDialog()"
		[attr.aria-label]="'globalSearch.closeSearch' | translate"
		class="close-button"
		type="button"
	>
		<icon
			[icon]="'fas fa-times'"
			class="w-5 h-5"
		/>
	</button>
	<div
		(click)="stopPropagation($event)"
		(keydown)="stopPropagation($event)"
		[attr.dir]="textDirection()"
		class="global-search-container-content"
		tabindex="0"
	>
		<div class="relative flex-shrink-0">
			<div class="global-search-input">
				<dc-search-input
					(termChanged)="onSearchTermChanged($event)"
					[initialTerm]="searchTerm()"
					[placeholder]="'globalSearch.searchPlaceholder' | translate"
				/>
			</div>

			<div class="tabs-and-filters-container">
				<div class="flex-grow">
					<dc-tab-navigation
						(categorySelected)="onCategorySelected($event)"
						[activeCategory]="activeCategory()"
						[categories]="categories"
					/>
				</div>
				<button
					(click)="toggleFiltersPanel()"
					[attr.aria-expanded]="isFiltersPanelOpen()"
					class="filters-button"
					type="button"
				>
					<icon
						[icon]="'fas fa-filter'"
						class="w-4 h-4"
					/>
					<span>{{ 'globalSearch.filters' | translate }}</span>
					@if (activeFiltersCount() > 0) {
						<span class="bg-blue-500 text-white text-xs rounded-full px-1.5 py-0.5">
							{{ activeFiltersCount() }}
						</span>
					}
				</button>
			</div>
		</div>

		<div class="flex-grow min-h-0 flex overflow-hidden">
			<div class="results-area dc-scrollbar">
				<dc-search-results
					(loadMore)="onLoadMore()"
					(pageSizeChange)="onPageSizeChange($event)"
					(sortByChange)="onSortByChange($event)"
					(sortDirectionChange)="onSortDirectionChange($event)"
					[category]="activeCategory()"
					[error]="error()"
					[loading]="loading()"
					[pageSize]="pageSize()"
					[results]="results()"
					[searchTerm]="searchTerm()"
					[sortBy]="activeCategorySorting().sortBy"
					[sortDirection]="activeCategorySorting().sortDirection"
					[total]="totalResults()"
				/>
			</div>

			<div
				[class.active]="isFiltersPanelOpen()"
				[class.inactive]="!isFiltersPanelOpen()"
				class="filters-aside"
			>
				<div class="flex justify-between items-center mb-4">
					<h3 class="text-lg font-semibold">{{ 'globalSearch.advancedFilters' | translate }}</h3>
					<button
						(click)="toggleFiltersPanel(false)"
						[attr.aria-label]="'globalSearch.closeFilters' | translate"
						class="close-aside-button"
						type="button"
					>
						<icon
							[icon]="'fas fa-times fa-fw'"
							class="w-5 h-5"
						/>
					</button>
				</div>

				@if (filterDefinitions().length > 0) {
					<dc-filter-panel
						[definitions]="filterDefinitions()"
						[currentFilters]="activeFilters()"
						(filterChanged)="onFilterChanged($event)"
					/>
				} @else {
					<p class="text-sm text-gray-500 italic">{{ 'globalSearch.noFiltersAvailable' | translate }}</p>
				}
			</div>
		</div>
	</div>
</div>
